import axios from '@/axios'

export default {
  /**
   * Get recent changes for the organisation
   * @param {number} limit - Maximum number of entries to return
   */
  getRecentChanges(limit = 100) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit/recent?limit=${limit}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Get audit history for a specific record
   * @param {string} tableName - Name of the table
   * @param {number} recordId - ID of the record
   * @param {number} limit - Maximum number of entries to return
   */
  getRecordHistory(tableName, recordId, limit = 50) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/audit/${tableName}/${recordId}?limit=${limit}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },

  /**
   * Undo a specific change
   * @param {number} auditLogId - ID of the audit log entry to undo
   */
  undoChange(auditLogId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/audit/undo/${auditLogId}`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
